import React from "react";

import clsx from "clsx";

import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { type SalesTableVisualRow } from "@features/sales-v3/types/table";

export const StatusDataFormatter = ({
  column,
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const row = _row as SalesTableVisualRow;

  const statuses = row?.rowMetadata?.statuses;

  return (
    <div className="flex items-center h-full px-3 font-sans space-x-1 overflow-hidden	">
      {statuses
        ?.slice()
        ?.sort()
        ?.map((status) => {
          return (
            <span
              key={status}
              className={clsx("py-0.5 px-2.5 rounded capitalize", {
                "bg-alien-2 text-[#3B8139]": status === "active",
                "bg-interstellar-3": status !== "active",
              })}
            >
              {status}
            </span>
          );
        })}
    </div>
  );
};
